<template>
  <div>
    <div class="cat-name">
      线上班级开班情况
    </div>
    <div class="search-header">
      <div class="fil-view">
        <div
          :class="['sel-btn', actDay === 1 ? 'active' : '']"
          @click="dayChange(1)"
        >
          7日
        </div>
        <div
          :class="['sel-btn', actDay === 2 ? 'active' : '']"
          @click="dayChange(2)"
        >
          30日
        </div>
        <div>
          <el-form :inline="true" :model="filters" :size="size">
            <el-form-item class="m-l-14">
              <el-date-picker
                v-model="dateArea"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <butn
                btntype="primary"
                title="查询"
                @click.native="initData"
              ></butn>
              <butn 
                title="导出数据"
                v-permission="'export:onlineClassStatistics'"
                @click.native="exportTable"
              ></butn>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="logo-tip">
        <div class="tip-item" v-for="(item, idx) in tipList" :key="idx">
          <TipLogo :bgColor="item.color" />
          <div class="tip-char">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="mar-30" id="class-open-info"></div>
  </div>
</template>

<script>
import { Chart } from "@antv/g2";
import moment from "moment";
import butn from "@/components/button/index";
import { ioRead } from "@/utils/common.js";
import TipLogo from "@/pages/activityStatistics/tipLogo.vue";
import {
  getOnlineClassStattistics,
  exportOnlineClassStatis
} from '@/api/class.js'

export default {
  props: ["deptId", "userType"],
  components: {
    butn,
    TipLogo,
  },
  watch: {
    deptId: {
      handler(val, oldVal) {
        if (val) {
          this.params.deptId = val;
          this.query();
        } else {
          this.query();
        }
      },
      immediate: true,
    },
  },

  data() {
    return {
      size: "small",
      actDay: 1,
      nowDay: moment(new Date()).format("YYYY-MM-DD"),
      sevenDay: moment(moment().add(6, 'days')).format("YYYY-MM-DD"),
      ssDay: moment(moment().add(29, 'days')).format("YYYY-MM-DD"),
      filters: {},
      dateArea: [],
      pickerMinDate: null,
      listData: [],
      chartData: [],
      chart: null,
      pickerOptions1: {
        onPick: ({ maxDate, minDate }) => {
          this.pickerMinDate = minDate.getTime();
          if (maxDate) {
            this.pickerMinDate = "";
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            const day30 = (30 - 1) * 24 * 3600 * 1000;
            let maxTime = this.pickerMinDate + day30;
            let minTime = this.pickerMinDate - day30;
            if (maxTime > new Date()) {
              maxTime = new Date();
            }
            return time.getTime() > maxTime || time.getTime() < minTime;
          }
          return time.getTime() > Date.now();
        },
      },
      params: {
        deptId: "",
        start: null,
        end: null,
      },
      tipList: [
        { name: "培训人次", color: "#3A85FF" },
        { name: "培训班次", color: "#2ABEF9" },
      ],
      chartDatas: [],
    };
  },
  mounted() {
    // this.drawChart();
  },
  methods: {
    drawChart() {
      let chart = new Chart({
        container: "class-open-info",
        autoFit: true,
        height: 300,
        appendPadding: [20, 0, 20],
      });
      this.chart = this.renderChart(chart);
    },
    dayChange(val) {
      this.actDay = val;
      this.query();
    },
    query() {
      switch (this.actDay) {
        case 1:
          this.params.start =  this.nowDay;
          this.params.end = this.sevenDay;
          break;
        case 2:
          this.params.start = this.nowDay;
          this.params.end = this.ssDay;
          break;
        case 3:
          this.params.start = this.dateArea[0];
          this.params.end = this.dateArea[1];
          break;
        default:
          break;
      }
      getOnlineClassStattistics(this.params).then(({ code, data }) => {
        if (code === 0) {
          this.chartDatas = data;
          this.changeChart();
        }
      });
    },
    changeChart() {
      if (!this.chart) {
        this.$nextTick(() => {
          this.drawChart()
        })
        return;
      }
      this.chart.clear();
      this.chart = this.renderChart(this.chart);
    },
    initData() {
      if (!this.dateArea || this.dateArea.length < 2) {
        this.$message.error("请选择日期范围！");
      } else {
        this.params.start = this.dateArea[0];
        this.params.end = this.dateArea[1];
        this.dayChange(3);
      }
    },
    // 导出
    exportTable() {
      switch (this.actDay) {
        case 1:
          this.params.start =  this.nowDay;
          this.params.end = this.sevenDay;
          break;
        case 2:
          this.params.start = this.nowDay;
          this.params.end = this.ssDay;
          break;
        case 3:
          this.params.start = this.dateArea[0];
          this.params.end = this.dateArea[1];
          break;
        default:
          break;
      }
      exportOnlineClassStatis(this.params).then((res) => {
        ioRead(res);
      });
    },
    getScale () {
      return  {
        date: {
          alias: "日期",
          type: "time",
        },
        trainNum: {
          alias: "培训人次",
          min: 0,
          max: this.maxValue("trainNum"),
        },
        trainClassNum: {
          alias: "培训班次",
          min: 0,
          max: this.maxValue("trainClassNum"),
        },
      };
    },

    renderChart (chart) {
      chart.data(this.chartDatas);
      chart.scale(this.getScale());
      chart.tooltip({
        showCrosshairs: true,
        shared: true,
        showTitle: true,
      });
      chart.axis("trainNum", {
        grid: null,
        title: {
          position: 'end',
          rotate: 0,
          text: '人次',
          textStyle: {
            fill: "#808080",
            fontSize: 12,
          },
        },
      });
      chart.axis("trainClassNum", {
        grid: null,
        title: {
          position: 'end',
          rotate: 0,
          text: '班次',
          textStyle: {
            fill: "#808080",
            fontSize: 12,
            textBaseline: "start"
          },
        },
      });
      chart
        .line()
        .position("date*trainNum")
        .color("#3A85FF")
        .size(4)
        .shape("smooth");
      chart
        .line()
        .position("date*trainClassNum")
        .color("#2ABEF9")
        .size(4)
        .shape("smooth");
      chart.render();
      return chart;
    },

    maxValue(key) {
      let maxValue = this.chartDatas.reduce((max, current) => {
        return current[key] > max ? current[key] : max;
      }, this.chartDatas[0][key]);
      return maxValue + 10;
    },
  },
};
</script>

<style lang="scss" scoped>
.cat-name {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #343c4a;
  padding: 30px 0 24px 0;
  .info-text {
    font-size: 12px;
  }
}
.search-header {
  display: flex;
  justify-content: space-between;
}

.fil-view {
  display: flex;
  .sel-btn {
    min-width: 73px !important;
    height: 28px;
    line-height: 28px;
    background: #ffffff;
    border: 1px solid #d7dbe0;
    border-radius: 5px;
    margin-right: 8px;
    text-align: center;
    cursor: pointer;
    &.active {
      background: rgba(58, 133, 255, 0.21);
      border: 1px solid #3a85ff;
    }
  }
}
.logo-tip {
  display: flex;
  align-items: center;
  height: 35px;
  .tip-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    .tip-char {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #51627d;
      margin-right: 24px;
      margin-left: 3px;
    }
  }
}
.table-view {
  display: flex;
  .fix-item {
    width: 90px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
  .row-title {
    width: 180px;
  }
  .top {
    background: #dce7fa;
    font-weight: 500;
    color: #343c4a;
  }
  .right {
    flex: 1;
    display: flex;
    overflow: auto;
  }
}
.mar-30 {
  margin: 10px 0;
}
</style>
